export enum SearchListType {
  COMPACT = 'compact',
  FULL = 'full',
}
